// @unocss-include
'use client';
import { Component } from 'react';
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: null,
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { error };
    }
    render() {
        if (this.state.error) {
            if (typeof this.props.fallback === 'function') {
                return this.props.fallback({
                    error: this.state.error,
                    clearError: () => this.setState({ error: null }),
                });
            }
            return this.props.fallback || null;
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map